import React from 'react';
import { useTranslation } from 'react-i18next';
import { Blend } from 'lucide-react';

import CommonDropdown from '../../../../../components/common-dropdown/CommonDropdown';
import CommonSlider from '../../../../../components/common-slider/CommonSlider';
import { BLEND_MODES } from '../../../../config';
import { useMediaStudio } from '../../../../context/MediaStudioContext';
import { ELEMENT_TYPES } from '../../../../core/documentSchema';
import InspectorSection from '../inspector-section/InspectorSection';

import scss from './AppearanceSection.module.scss';

const sharedValue = (values) => (values.every((value) => value === values[0]) ? values[0] : null);

function AppearanceSection({ element, elements = [element] }) {
  const { t } = useTranslation('mediaStudio');
  const { editor } = useMediaStudio();
  const isGroup = elements.length > 1;
  const showOpacity = elements.every((item) => item.type !== ELEMENT_TYPES.SHAPE);
  const showBlend = elements.every((item) => item.type !== ELEMENT_TYPES.TEXT);
  const blendOptions = BLEND_MODES.map((mode) => ({ value: mode.id, label: t(mode.labelKey) }));
  const opacity = sharedValue(elements.map((item) => item.opacity));
  const blendMode = sharedValue(elements.map((item) => item.blendMode));

  const apply = (changes, options) => {
    if (isGroup) {
      editor.changeElements(
        elements.map((item) => ({ id: item.id, changes })),
        options,
      );
    } else {
      editor.change(element.id, changes, options);
    }
  };

  return (
    <InspectorSection title={t('appearance')}>
      {showOpacity ? (
        <CommonSlider
          label={t('opacity')}
          icon={Blend}
          min={0}
          max={100}
          value={opacity == null ? 100 : Math.round(opacity * 100)}
          resetValue={100}
          resetLabel={t('resetSlider')}
          onChange={(value) => apply({ opacity: value / 100 }, { live: true })}
          onCommit={editor.endGesture}
          valueFormatter={(value) => (opacity == null ? t('mixed') : `${value}%`)}
        />
      ) : null}
      {showBlend ? (
        <div className={scss.blendField}>
          <span className={scss.blendLabel}>{t('blend')}</span>
          <CommonDropdown
            options={blendOptions}
            value={blendMode}
            placeholder={blendMode == null ? t('mixed') : undefined}
            onSelect={(nextBlendMode) => apply({ blendMode: nextBlendMode })}
            isBorder
            maxWidth={180}
          />
        </div>
      ) : null}
    </InspectorSection>
  );
}

export default AppearanceSection;
